module.exports = __webpack_public_path__ + "static/media/album-cover.cebb5409.svg";